import React, {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {
  Text,
  View,
  Dimensions,
  StyleSheet,
  TouchableOpacity,
  Modal,
} from 'react-native';
import HomeHeader from '../../components/HomeHeader';
import {AiFillStar, AiOutlineStar} from 'react-icons/ai';
import {TextInput} from 'react-native';
import {giveFeedback} from '../../network/Network';

const HEIGHT = Dimensions.get('window').height;

export default function FeedbackScreen(props) {

  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');
  const [error, setError] = useState('');
  const [modal, setModal] = useState(false);

  const setFeedback = () => {
    giveFeedback(rating, review)
      .then((resp) => {
        if (resp.status === 201) {
          setModal(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const checkCondation = () => {
    if (review.length === 0 && rating === 0) {
      setError('Give Your Rating & Review');
    } else if (review.length === 0) {
      setError('Give Your Review');
    } else if (rating === 0) {
      setError('Give Your Rating');
    } else {
      setError('');
      setFeedback();
    }
  };

  return (
    <View
      style={{
        backgroundColor: '#1a191f',
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation} />
      <Container>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <View style={styles.feedback}>
              <Text style={styles.header}>Give Your Ratings</Text>
              <View style={styles.ratings}>
                <TouchableOpacity onPress={() => setRating(1)}>
                  {rating >= 1 ? (
                    <AiFillStar color="red" size={25} />
                  ) : (
                    <AiOutlineStar color="gray" size={25} />
                  )}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating(2)}>
                  {rating >= 2 ? (
                    <AiFillStar color="red" size={25} />
                  ) : (
                    <AiOutlineStar color="gray" size={25} />
                  )}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating(3)}>
                  {rating >= 3 ? (
                    <AiFillStar color="red" size={25} />
                  ) : (
                    <AiOutlineStar color="gray" size={25} />
                  )}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating(4)}>
                  {rating >= 4 ? (
                    <AiFillStar color="red" size={25} />
                  ) : (
                    <AiOutlineStar color="gray" size={25} />
                  )}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => setRating(5)}>
                  {rating === 5 ? (
                    <AiFillStar color="red" size={25} />
                  ) : (
                    <AiOutlineStar color="gray" size={25} />
                  )}
                </TouchableOpacity>
              </View>
              <TextInput
                placeholder="Give us a Review"
                style={styles.review}
                multiline={true}
                onChange={(event) => setReview(event.target.value)}
                numberOfLines={7}
              />
              {error.length != 0 ? (
                <Text style={styles.error}>{error}</Text>
              ) : null}
              <TouchableOpacity
                style={styles.button}
                onPress={() => {
                  checkCondation();
                }}>
                <Text style={styles.buttonText}>Submit</Text>
              </TouchableOpacity>
            </View>
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>

      {/* Confirmation modal */}
      <Modal visible={modal}>
        <Text>hi</Text>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: 18,
    color: 'lightgray',
    fontWeight: 'bold',
    alignSelf: 'center',
    letterSpacing: 1,
  },
  feedback: {
    boxShadow: `${0}px ${0}px ${8}px #d3d3d336`,
    marginVertical: 30,
    borderRadius: 5,
    paddingVertical: 30,
  },
  ratings: {
    alignSelf: 'center',
    marginTop: 15,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  review: {
    marginVertical: 20,
    borderColor: 'gray',
    borderWidth: 0.5,
    color: 'gray',
    alignSelf: 'center',
    width: '80%',
    padding: 10,
    borderRadius: 4,
  },
  button: {
    alignSelf: 'center',
    backgroundColor: '#e10808',
    borderRadius: 5,
    width: '22%',
    paddingVertical: 10,
    alignItems: 'center',
    marginTop: 10,
  },
  buttonText: {
    fontFamily: 'Source Sans Pro, sans-serif',
    color: 'white',
    letterSpacing: 1,
  },
  error: {
    textAlign: 'center',
    color: 'red',
    marginVertical: 10,
  },
});
